import _ from 'lodash'
import React, { useEffect, useState, useRef } from 'react'
import { YesNoRendererComponent } from '../../yes-no-renderer.component'
import { currency, format, formatDate } from '../../../services/common.service'
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { ExpandTableContainer } from '../../../expand-table/containers/expand-table.container'
import * as R from 'ramda';
import { useAppDispatch } from '../../../../hooks/hooks'
import { InputContainer } from '../../form/input/containers/input.container'
import { CopyRendererComponent } from '../../copy-renderer.component'
import { ViewRendererComponent } from '../../view-renderer.component'
import { useConfirm } from '../../../../hooks/useConfirm'
import { MdTableView } from 'react-icons/md'
import { FilterDrawerComponent } from '../../table-manager/filter-drawer'
import { CategoriesActionMenus, ChannelsActionMenus, CollectionPointsActionMenus, CollectionsPolicyActionMenus, DiscountsPolicyActionMenus, OrgRegistryActionMenus, PickupPointsActionMenus, ProductActionMenus, ProductionPlantsActionMenus, ProductionUnitsActionMenus, StoresActionMenus, VendorProductsActionMenus, WarehouseActionMenus, WebPagesActionMenus } from '../../table-manager/action-menus'
import { CategoryContextMenus, CollectionPolicyContextMenus, CreditDebitNotesContextMenus, DiscountPolicyContextMenus, OnboardContextMenus, PublishVendorToCloudContextMenus, ResetContextMenus, WebPagesContextMenus, WebsitesContextMenus } from '../../table-manager/context-menus'
import { ValueComponent } from '../../value.component';
import PaginationContainer from '../../../pagination/container/pagination.container';
import { LibraryRendererComponent } from '../../library-renderer-1.0.component';
import { AccountMoreContextMenus } from '../context-menus/account-context-menu';
import { AccountsActionMenus } from '../action-menus/accounts-action-menus';

interface CheckboxConfig<T = any> {
	isDisabled?: boolean; // If checkboxes are disabled
	allowMultiSelect?: boolean;
	defaultSelectedIds?: Array<T[keyof T]>; // Default selected rows based on a dynamic key
	keyColumn?: keyof T; // Dynamic key for selection
}

interface TablePagination {
	paginationData?: any; // Pagination data (define more specifically if possible)
	setPageData?: (page: number) => void; // Function to update page data
	setPageSize?: (size: number) => void; // Function to update page size
}

interface TableFilters {
	enableFilter?: boolean; // Enable or disable filter
	searchCriteriaList?: any[]; // List of search criteria
	filterTypeLists?: any[]; // List of filter types
	filterBy?: string; // Current filter value
	handleInputChange?: (input: any, fiedl: any, row: any) => void; // Handle filter input changes
}

interface TableActions {
	onSelect?: (selectedRows: any[]) => void; // Callback for row selection
	// onSelectAll?: () => void; // Callback for "Select All" action
	onEdit?: (row: any) => void; // Callback for edit action
	onDelete?: (row: any) => void; // Callback for delete action
	onSearch?: (query: string) => void; // Callback for search action
}

interface TableProps<T = any> extends TablePagination, TableFilters, TableActions {
	columnData: any; // Table column definitions
	rowData: T[]; // Table rows
	checkboxConfig: CheckboxConfig<T>; // Checkbox configuration
	// allowMultiSelect?: boolean; // Allow multi-selection
	additionButtons?: any[]; // Additional custom buttons
	headingName: string; // Table heading
	customFunctions?: any[]; // Custom functions
	[key: string]: any; // Dynamic additional properties
}

const Table = <T extends object>({ handleParticularOrgRegistry, IsPublishParticularVendorToCloud, handlePublishTenantWebsite, setPageSize, handleRunScheduledTask, isEdocs, subColumnDefs, handleReset, IsReset,
	onEnabledActiveStatusClick, onOrderStatusClick, launchId, onGeneratePin, launchLabel, baseUrl,
	onPaymentStatusClick, onFullfillmentStatusClick, onReturnRequestStatusClick,
	columnData, rowData,
	onSelect = () => { },
	handleClickAttributeValues = () => { },
	customFunctions,
	onSearch = () => { },
	onEdit, additionButtons, onDelete, headingName, paginationData, setPageData, onShippingStatusClick,
	enableFilter = false,
	searchCriteriaList,
	filterTypeLists,
	filterBy,
	handleInputChange,
	handlePublishAccounts,
	onGeneratePdfInvoice = () => { },
	onGeneratePrintOrderInvoice = () => { },
	handleUpdateTenantWebsite, handlereset, handleEnableTenantWebsite, IsRowUpdated, handleSave,
	handleCDNUpdateWebsite,
	handleCDNReset,
	handleCDNDelete,
	IsWebsites,
	IsOnboard,
	IsWebPages,
	IsAccountMoreActions,
	IsMoreActionButtonsProducts,
	handleExportProducts,
	handleAddAttribute,
	handleUploadProductClick,
	handleAddTagsProducts,
	IsPublishAccounts,
	handlePublishProducts, isDBNVendors,
	IsPolicyCollectionsMoreActions,
	handlepublishPolicyCollectionPage,
	handleAccountPermanentlyDelete,
	IsMoreActionButtonsVendorProducts,
	handlePublishVendorProducts,
	IsMoreActionsPolicyDiscount,
	handlePublishPolicyDiscounts,
	IsMoreActionButtonPolicyDiscounts,
	IsMoreActionButtonPolicyCollections,
	IsMoreActionButtonsOrgRegistry,
	handlePopulateOrgRegistry,
	handleUpdateCDNWebPage,
	handlePublishWebPage,
	handleUpdateCDNWebPages,
	handleResetCDNWebpages,
	handleDeleteCDNWebpages,
	handlePublishWebPages,
	handleDeleteForAllVendors,
	handleresetForAllVendors,
	handleAddNewCardsForAllVendors,
	IsMoreActionButtonCatagories,
	handlePublishCatagoriesPage,
	IsMoreActionsCatagory,
	handleOnBoard, checkboxConfig, handleGlobalOrgRegistries,
	onApprovalStatusClick,
	IsActionButton,
	IsMoreActionsCreditDebitNotes,
	handleCreditDebitNotesRefundAmountPage, handleEnableSEOTenantWebsite,
	handleEnableSEOAccountWebPage,
	IsMoreActionButtonsStores,
	handleStoreChannels,
	handlePickupPoints,
	IsMoreActionButtonsChannels,
	handleStores,
	IsMoreActionButtonsCollectionPoints,
	handleWarehouseClick,
	IsMoreActionButtonsWarehouse,
	handleCollectionPointClick,
	IsMoreActionButtonsPickupPoints,
	IsMoreActionButtonsProductionPlants,
	handleProductionUnits,
	IsMoreActionButtonsProductionUnits,
	handleProductionPlants,
}: TableProps<T>) => {
	const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);
	const { isDisabled, allowMultiSelect = true, defaultSelectedIds = [], keyColumn } = checkboxConfig || {};
	const [showFilter, setShowFilter] = useState(false);
	let filterOptions: any = []
	const dispatch = useAppDispatch();
	const [selectedField, setSelectedField] = useState([]);
	const [filterType, setFilterType] = useState([])
	console.log('baseUrl', baseUrl)
	const [isExpand, setIsExpand] = useState(false);
	const [subRowData, setSubRowdata] = useState<any>();
	const [subRowDataId, setSubRowdataId] = useState<any>();
	const { confirm, modal } = useConfirm();
	const [selectedRows, setSelectedRows] = useState<Set<T[typeof keyColumn]>>(new Set());
	const { PageNumber, PageSize } = paginationData || { PageNumber: 1, PageSize: 10 };
	const startIndex = (PageNumber - 1) * PageSize + 1;

	const [filteredData, setFilteredData] = useState<any>(rowData);

	const selectAllRef = useRef<HTMLInputElement>(null);
	const isInitialized = useRef(false); // Track initialization of default selection

	// Pre-select rows based on defaultSelectedIds
	// Initialize default selected rows only once
	useEffect(() => {
		if (!isInitialized.current && defaultSelectedIds.length > 0) {
			const defaultSelection = new Set(defaultSelectedIds);
			setSelectedRows(defaultSelection);
			isInitialized.current = true;
		}
	}, [defaultSelectedIds]);

	// Toggle row selection
	const handleRowSelect = (id: T[typeof keyColumn]) => {
		console.log('Table Id', id)
		setSelectedRows((prevSelected) => {
			const newSelected = new Set(prevSelected);
			if (allowMultiSelect) {
				// For multiselect: toggle the row
				newSelected.has(id) ? newSelected.delete(id) : newSelected.add(id);
			} else {
				// For single select: clear all and select the current row
				newSelected.clear();
				newSelected.add(id);
			}
			return newSelected;
		});
	};

	console.log("KeyColumn:", keyColumn);
	console.log("RowData:", rowData);

	// Toggle "Select All"
	const handleSelectAll = () => {
		setSelectedRows((prevSelected) => {
			if (prevSelected.size === filteredData.length) return new Set(); // Deselect all
			return new Set(filteredData.map((row) => row[keyColumn])); // Select all
		});
	};

	// Trigger callback when selection changes
	useEffect(() => {
		if (!onSelect || !Array.isArray(filteredData)) return;

		const selectedData = filteredData.filter((row) =>
			selectedRows.has(row[keyColumn])
		);

		onSelect(selectedData);
	}, [selectedRows, filteredData, onSelect, keyColumn]);

	// Set the indeterminate state programmatically
	useEffect(() => {
		if (selectAllRef.current) {
			selectAllRef.current.indeterminate =
				selectedRows.size > 0 && selectedRows.size < filteredData.length;
		}
	}, [selectedRows, filteredData]);

	const handleCellClick = async (column: any, data: any) => {
		console.log('column', column)
		if (column?.isEdit) {
			onEdit(data)
		}
	}

	const handleClickDelete = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to delete ?');
		if (isConfirmed) {
			handleDelete(data)
		}
	};

	const handleClickReset = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Reset?');
		if (isConfirmed) {
			handlereset(data)
		}
	};

	const handleClickDeleteForAllVendors = async () => {
		const isConfirmed = await confirm('Are you sure you want to delete ?');
		if (isConfirmed) {
			handleDeleteForAllVendors()
		}
	};
	const handleClickAccountPermanentlyDelete = async (data: any) => {
		const isConfirmed = await confirm(`Are you sure you want to delete the "${data?.Email}" account permanently ?`);
		if (isConfirmed) {
			handleAccountPermanentlyDelete(data)
		}
	};
	const handleClickResetForAllVendors = async () => {
		const isConfirmed = await confirm('Are you sure you want to Reset?');
		if (isConfirmed) {
			handleresetForAllVendors()
		}
	};

	const handleGeneratePdfInvoice = async (data: any) => {
		onGeneratePdfInvoice(data);
	}

	const handleGeneratePrintOrdersInvoice = async (data: any) => {
		onGeneratePrintOrderInvoice(data);
	}

	const handleCDNDeleteClick = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Delete this  entries in CDN?');
		if (isConfirmed) {
			handleCDNDelete(data)
		}
	};
	const handleCDNResetClick = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Reset this  entries in CDN?');
		if (isConfirmed) {
			handleCDNReset(data)
		}
	};

	const handleDeleteCDNForAll = async () => {
		const isConfirmed = await confirm('Are you sure you want to Delete entries for all Vendors in CDN?');
		if (isConfirmed) {
			handleDeleteCDNWebpages()
		}
	};
	const handleResetCDNForAll = async () => {
		const isConfirmed = await confirm('Are you sure you want to Reset entries for all Vendors  entries in CDN?');
		if (isConfirmed) {
			handleResetCDNWebpages()
		}
	};


	const handleSubRowData = (data: any) => {
		setIsExpand(!isExpand)
		if (data?.AssociatedDomains) {
			setSubRowdataId(data?.Id)
			setSubRowdata(data?.AssociatedDomains)
		} else if (data?.TenantDomainFunctions) {
			setSubRowdataId(data?.Id)
			setSubRowdata(data?.TenantDomainFunctions)
		} else if (data?.Products) {
			setSubRowdataId(data?.Id)
			setSubRowdata(data?.Products)
		}

	}
	const filteredFields = _.filter(
		columnData,
		(item) => item.field !== 'Sl' && item.field !== 'Edit'
	)
	const [isCheckAll, setIsCheckAll] = useState(false)


	useEffect(() => {
		console.log(selectedField)
		const newdata: any = [...filterType, "string"]
		setFilterType(newdata)

	}, [selectedField])

	useEffect(() => {
		setFilteredData([...(rowData || [])]);
	}, [rowData]);

	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
		onDelete(item)
	}

	const handleFilterType = (e: any, idx: any) => {
		let arr: any = []
		filterType.map((obj: any, index: any) => {
			if (idx == index) {
				arr.push(e.target.value)
			}
			else {
				arr.push(obj)
			}
		})
		setFilterType(arr)
	}

	useEffect(() => {
		if (filteredFields) {
			const filteredDataList: any[] = []
			R.map((data: any) => {
				filteredDataList.push({
					label: data?.headerName,
					value: data?.field
				})
				return data;
			})(filteredFields)
			filterOptions = filteredDataList
		}



	}, [])

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		return event.target.checked;
	};



	useEffect(() => {
		console.log('filteredData', filteredData)
	}, [filteredData]);

	return (

		<div className={`p-4 w-[calc(100%)]`}>
			<div className="flex my-2  w-full justify-between items-center px-2">
				<div className="uppercase text-xl">
					{headingName ? headingName : ''}
				</div>
				<div className=' flex flex-row items-end justify-end text-end '>

					{additionButtons?.length > 0 &&
						additionButtons.map((button: any, index: number) => (
							<button
								key={index}
								onClick={(event) => !button.disabled && button.callback(event)}
								type="button"
								disabled={button.disabled}
								className={`group flex items-center mr-2 rounded font-medium px-4 py-2 
        ${button.disabled ? "bg-gray-400 cursor-not-allowed text-white" : "bg-blue-700 text-white hover:bg-blue-800"}`}
								title={button.name === "Add Default" ? "Add Default web pages for all the vendors" : ""}
							>
								<span>{button.svg}</span>
								<span className="ml-1">{button.name}</span>
							</button>
						))}

					{enableFilter && <button
						onClick={() => setShowFilter(!showFilter)}
						type="button"
						className="group flex items-center bg-blue-700 text-white rounded font-medium px-4 py-2 "
					>
						<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
							<title>Search and Filters</title>
							<path d="M2.73224 5.32873C1.58574 4.03892 2.50136 2 4.22706 2H19.7734C21.4991 2 22.4147 4.03893 21.2682 5.32873L15.0002 12.3802V21C15.0002 21.3466 14.8208 21.6684 14.5259 21.8507C14.2311 22.0329 13.863 22.0494 13.553 21.8944L9.553 19.8944C9.21421 19.725 9.00021 19.3788 9.00021 19V12.3802L2.73224 5.32873ZM19.7734 4H4.22706L10.7476 11.3356C10.9103 11.5187 11.0002 11.7551 11.0002 12V18.382L13.0002 19.382V12C13.0002 11.7551 13.0901 11.5187 13.2528 11.3356L19.7734 4Z" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</button>}
					<div className='px-2'>
						{IsMoreActionButtonsProducts &&
							<ProductActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleExportProducts={handleExportProducts} handleAddAttribute={handleAddAttribute} handleUploadProductClick={handleUploadProductClick} handleAddTagsProducts={handleAddTagsProducts} />
						}
						{IsMoreActionButtonsOrgRegistry &&
							<OrgRegistryActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePopulateOrgRegistry={handlePopulateOrgRegistry} />
						}
						{IsWebPages &&
							<WebPagesActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishWebPages={handlePublishWebPages} handleUpdateCDNWebPages={handleUpdateCDNWebPages} handleResetCDNForAll={handleResetCDNForAll} handleDeleteCDNForAll={handleDeleteCDNForAll} handleAddNewCardsForAllVendors={handleAddNewCardsForAllVendors} handleClickResetForAllVendors={handleClickResetForAllVendors} handleClickDeleteForAllVendors={handleClickDeleteForAllVendors} />
						}
						{IsMoreActionButtonsVendorProducts &&
							<VendorProductsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishVendorProducts={handlePublishVendorProducts} />
						}
						{IsMoreActionButtonPolicyDiscounts &&
							<DiscountsPolicyActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishPolicyDiscounts={handlePublishPolicyDiscounts} />
						}
						{IsMoreActionButtonPolicyCollections &&
							<CollectionsPolicyActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlepublishPolicyCollectionPage={handlepublishPolicyCollectionPage} />
						}
						{IsMoreActionButtonCatagories &&
							<CategoriesActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishCatagoriesPage={handlePublishCatagoriesPage} />
						}
						{IsMoreActionButtonsStores &&
							<StoresActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleStoreChannels={handleStoreChannels} handlePickupPoints={handlePickupPoints} />
						}
						{IsMoreActionButtonsChannels &&
							<ChannelsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleStores={handleStores} />
						}
						{IsMoreActionButtonsCollectionPoints &&
							<CollectionPointsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleWarehouseClick={handleWarehouseClick} />
						}
						{IsMoreActionButtonsWarehouse &&
							<WarehouseActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleCollectionPointClick={handleCollectionPointClick} />
						}
						{IsMoreActionButtonsPickupPoints &&
							<PickupPointsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleStores={handleStores} />
						}
						{IsMoreActionButtonsProductionUnits &&
							<ProductionUnitsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleProductionPlants={handleProductionPlants} />
						}
						{IsMoreActionButtonsProductionPlants &&
							<ProductionPlantsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleProductionUnits={handleProductionUnits} />
						}
						{IsPublishAccounts &&
							<AccountsActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishAccounts={handlePublishAccounts} />
						}
					</div>
				</div>
				{/* {enableFilter && <TableFilterComponent columnData={columnData} rowData={rowData} filterTypeLists={filterTypeLists} setFilteredData={setFilteredData} />} */}
				{enableFilter && <FilterDrawerComponent
					columnData={columnData}
					rowData={rowData}
					filterTypeLists={filterTypeLists}
					searchCriteriaList={searchCriteriaList}
					setFilteredData={setFilteredData}
					initiateSearch={onSearch}
					showFilter={showFilter}
					setShowFilter={setShowFilter}
				/>}
			</div>

			<div className="flex my-2 w-full justify-end items-center px-2">

			</div>

			<div className="overflow-auto max-h-96 w-full">
				{filteredData?.length > 0 ? <table className="min-w-full text-xs bg-red-50">
					<thead className="sticky top-0 w-auto z-10">
						<tr key={'table'} className="bg-red-100 h-12 leading-normal">
							<th key={0}
								className="py-3 px-6 text-left">
								<input
									ref={selectAllRef}
									type="checkbox"
									onChange={handleSelectAll}
									checked={selectedRows.size === filteredData.length && filteredData.length > 0}

								/>
							</th>
							<th key={1} className='py-3 px-6 text-left border-r border-gray-100'>
								#
							</th>
							{columnData[0]?.isSortLabel ?
								filteredFields.map((column: any, index: any) => (
									<th key={index}
										className="py-3 px-6 truncate text-left border-r border-gray-100">{column.headerName}</th>

								))
								:
								filteredFields?.map((column: any, index: any) => (
									<th key={index}
										className="py-3 px-6 truncate text-left border border-gray-100">
										{column.headerName}
									</th>

								))}
							<th
								className="py-3 px-6 text-left">
								Action
							</th>
						</tr>
					</thead>
					<tbody className="bg-red-400 text-sm font-light max-h-24 overflow-y-auto">
						<>
							{filteredData && filteredData?.map((row: any, index: any) => (
								<><tr key={row[keyColumn] as React.Key}
									className="cursor-pointer even:bg-[#F8F9FAFF] odd:bg-white">
									<td key={0}>
										<span className="py-3 px-6 text-left cursor-pointer">


											<input
												type="checkbox"
												checked={selectedRows.has(row[keyColumn])}
												onChange={() => handleRowSelect(row[keyColumn])}
											/>

										</span>
									</td>
									<td key={1} className='py-3 px-6 text-left border-r border-gray-100'>
										{startIndex + index}
									</td>
									{filteredFields?.map((column) => {
										const dataValue: any = _.property(column.field)(row)
										const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
										return (

											<>
												<td key={index} className="py-3 px-6 border-r border-gray-100 text-left" onClick={() => handleCellClick(column, row)}>
													{!column.input &&
														column.cellRenderer !== 'resetIconRenderer' && column.isCurrencyValueFormat !== true && column.cellRenderer !== 'imageRenderer' && column.isAddressFormat !== true && column.isDateValueFormat !== true && column.isOnlyDateValueFormat !== true && column.cellRenderer !== 'yesNoRenderer' && column.cellRenderer !== 'libraryRendererComponent' && column.cellRenderer !== 'copyRenderer' &&
														column.cellRenderer !== 'viewRenderer' && !column.valueFormatter && !column.isGeneratedPDF && !column.isGeneratedPrintOrders &&
														<div
															className={`w-auto max-w-40 truncate ${column?.align} ${column?.isEdit ? 'underline cursor-pointer' : ''} ${column?.callback ? 'underline cursor-pointer hover:font-bold' : ''}`}
															title={dataValue}
															onClick={() => {
																if (column?.callback) {
																	column.callback(row);
																}
															}}
														>
															{/* {dataValue?.length > 40 ? `${dataValue.substring(0, 25)}...` : dataValue} */}
															{dataValue}
														</div>
													}
													{column.isGeneratedPDF && (
														// console.log('print', dataValue),
														<div className='flex items-center truncate cursor-pointer   hover:text-blue-800' onClick={() => { handleGeneratePdfInvoice(row) }} title={`Print - E-Way No: ${dataValue}`}>
															{dataValue}
															<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
																<text x="4" y="10" font-family="Arial" font-size="10" fill="red">PDF</text>
															</svg>
														</div>
													)}
													{column.isGeneratedPrintOrders && (
														// console.log('print', dataValue),
														<div className='flex items-center cursor-pointer  hover:text-blue-800' onClick={() => { handleGeneratePrintOrdersInvoice(row) }} title={`Print - Invoice No: ${dataValue}`}>
															{dataValue}
															<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
																<text x="4" y="10" font-family="Arial" font-size="10" fill="red">PDF</text>
															</svg>
														</div>
													)}
													{column.isDateValueFormat === true && (
														<p className="truncate">
															{format(dataValue)}
														</p>
													)}
													{column.isOnlyDateValueFormat === true && (
														<p className="truncate">
															{formatDate(dataValue)}
														</p>
													)}
													{column.isCurrencyValueFormat === true && (
														<p >
															{currency(dataValue)}
														</p>
													)}
													{column.valueFormatter && (
														<ValueComponent value={dataValue} valueFormatter={column.valueFormatter} />
													)}
													{column.isOnBoardToAgency &&
														<button
															type="button"
															className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
															onClick={() => handleOnBoard(row)}
														>
															OnBoard
														</button>}
													{column.isAddressFormat === true &&
														<p className='font-semibold truncate'
															title={address?.length > 25 ? address : ''}
														>
															{address?.length > 25 ? `${address.substring(0, 25)}...` : address}
														</p>
													}
													{column.cellRenderer === 'yesNoRenderer' && (
														<div className='flex justify-center items-center'>
															<YesNoRendererComponent
																cellRenderer={column.cellRenderer}
																onEnabledActiveStatusClick={onEnabledActiveStatusClick}
																value={dataValue}
																data={column}
																dataId={row}
															/>
														</div>
													)}
													{column.cellRenderer === 'viewRenderer' && (
														<div className='flex justify-center items-center'>
															<ViewRendererComponent
																data={row}
																onEdit={onEdit}
															/>
														</div>
													)}
													{column.cellRenderer === 'copyRenderer' && (
														<CopyRendererComponent data={row} />
													)}
													{column.cellRenderer === 'imageRenderer' && (
														<img src={dataValue} className="w-16 h-16 object-contain" />
													)}
													{column.cellRenderer === 'libraryRendererComponent' &&
														<div className='flex justify-center items-center'>
															<LibraryRendererComponent
																cellRendererParams={column.cellRendererParams}
																value={dataValue}
															/>
														</div>
													}


													{column.input && (
														<InputContainer
															type={column.type}
															value={dataValue}
															onValueChange={(event: any) => handleInputChange(event, column.field, row)}
															showToolTip
															className="w-full"
														/>
													)}
													{column.cellRenderer === 'AttributeValuesRenderer' && (
														<div className='flex justify-center items-center'>
															<button
																className="m-2 text-white rounded font-medium px-4 py-2"
																onClick={() => handleClickAttributeValues(row)}
																title='Show values of the selected product attribute'
															>
																<MdTableView className="text-gray-800 text-xl" />
															</button>
														</div>
													)}
													{column.isGlobalDBNPRegistry &&
														<button
															type="button"
															className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
															onClick={() => handleGlobalOrgRegistries(row)}
														>
															Vendors
														</button>}
													{column.cellRenderer === 'customFunctions' && <div className='flex flex-row px-2 justify-center items-center'>
														{_.map(customFunctions, (fn: any) => (
															<button
																className="m-2 text-white rounded font-medium px-4 py-2"
																onClick={() => fn.callback(row)}
																title={fn.title}
															>
																{fn.icon}
															</button>
														))}
													</div>
													}


													{column.isExecute &&
														<button
															type="button"
															className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
															onClick={() => handleRunScheduledTask(row)}
														>
															Run Now
														</button>}
													{column.isExpanded &&

														<button
															aria-label="expand row"
															className="p-2 text-2xl"

															onClick={() => handleSubRowData(row)}
														>
															{isExpand ? <HiChevronUp /> : <HiChevronDown />}
														</button>}

												</td>

											</>
										)
									})}
									{modal}
									<td key={9} className="flex p-5 w-max flex-row justify-center item-baseline cursor-pointer">
										<div className="flex items-center">
											<div className='flex flex-row justify-center items-center'>
												{onEdit && !isEdocs && !isDBNVendors && !IsActionButton && <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="14" height="14" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>}
												{!isDBNVendors && onDelete && !IsActionButton && <div className='pl-2'><svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleClickDelete(row)} width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>{modal}</div>}
												{isDBNVendors && <div className="flex items-center pl-2 cursor-pointer" onClick={() => handleGlobalOrgRegistries(row)}>
													<span>Proceed</span>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="currentColor"
														className="ml-1"
													>
														<path d="M10 17l5-5-5-5v10z" />
													</svg>
												</div>}
											</div>
											{IsActionButton &&
												<div className='flex w-full justify-end items-end'>
													<button
														onClick={() => onApprovalStatusClick(20, row)}
														type='button'
														className="bg-green-500 text-white p-2 rounded-lg mx-1"
													>
														Accept
													</button>
													<button
														onClick={() => onApprovalStatusClick(30, row)}
														type='button'
														className="bg-red-500 text-white p-2 rounded-lg mx-1"
													>
														Reject
													</button>
												</div>
											}
											{IsOnboard &&
												<OnboardContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleOnBoard={handleOnBoard} row={row} />
											}

											{IsPublishParticularVendorToCloud &&
												<PublishVendorToCloudContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleParticularOrgRegistry={handleParticularOrgRegistry} row={row} />
											}
											{IsWebsites &&
												<WebsitesContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishTenantWebsite={handlePublishTenantWebsite} handleCDNUpdateWebsite={handleCDNUpdateWebsite} handleCDNResetClick={handleCDNResetClick} handleCDNDeleteClick={handleCDNDeleteClick} handleEnableSEOTenantWebsite={handleEnableSEOTenantWebsite} handleSave={handleSave} handleUpdateTenantWebsite={handleUpdateTenantWebsite} handleEnableTenantWebsite={handleEnableTenantWebsite} handleClickReset={handleClickReset} row={row} />
											}
											{IsReset &&
												<ResetContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleReset={handleReset} row={row} />
											}
											{IsWebPages &&
												<WebPagesContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishWebPage={handlePublishWebPage} handleUpdateCDNWebPage={handleUpdateCDNWebPage} handleCDNResetClick={handleCDNResetClick} handleCDNDeleteClick={handleCDNDeleteClick} handleEnableSEOAccountWebPage={handleEnableSEOAccountWebPage} handleSave={handleSave} handleUpdateTenantWebsite={handleUpdateTenantWebsite} handleEnableTenantWebsite={handleEnableTenantWebsite} handleClickReset={handleClickReset} row={row} />
											}
											{IsAccountMoreActions &&
												<AccountMoreContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleClickAccountPermanentlyDelete={handleClickAccountPermanentlyDelete} row={row} />
											}
											{IsPolicyCollectionsMoreActions &&
												<CollectionPolicyContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlepublishPolicyCollectionPage={handlepublishPolicyCollectionPage} row={row} />
											}
											{IsMoreActionsPolicyDiscount &&
												<DiscountPolicyContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishPolicyDiscounts={handlePublishPolicyDiscounts} row={row} />
											}
											{IsMoreActionsCatagory &&
												<CategoryContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handlePublishCatagoriesPage={handlePublishCatagoriesPage} row={row} />
											}
											{IsMoreActionsCreditDebitNotes &&
												<CreditDebitNotesContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleCreditDebitNotesRefundAmountPage={handleCreditDebitNotesRefundAmountPage} row={row} />
											}
										</div>
									</td>
								</tr>
									<ExpandTableContainer
										subRowData={subRowData}
										isExpand={isExpand}
										subRowDataId={subRowDataId}
										subColumnDefs={subColumnDefs}
										row={row}
										columnData={columnData} /></>
							)
							)
							}
						</>
					</tbody>
				</table>
					:
					<div className='w-full flex justify-center items-center text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
			</div>

			{filteredData?.length !== 0 ? <div className="flex items-center justify-center w-full gap-8 my-2">
				<PaginationContainer
					pages={paginationData}
					handleChangeRowsPerPage={setPageSize}
					handleFirstPageButtonClick={() => setPageData(1)}
					handleBackButtonClick={() => setPageData(paginationData?.PageNumber - 1)}
					handleNextButtonClick={() => setPageData(paginationData?.PageNumber + 1)}
					handleLastPageButtonClick={() => setPageData(paginationData?.TotalPages || 1)}
				/>
			</div> : ''}
		</div>




	)
}

export default Table